module.exports = __webpack_public_path__ + "static/media/print.ca2d471b.svg";